import {
  Box,
  Text,
} from "@salestrak/ui";
import {
  SYSTEM_ROLE_DESCRIPTIONS,
  SYSTEM_ROLE_NAMES,
  type SystemRole,
} from "@salestrak/permissions";
import { PermissionsSection } from "#app/components/settings/permissions/permissions-section";

// System roles shown in the "Roles" header strip. Owner is excluded —
// it's an all-access role and isn't shown alongside the editable tiers.
const ROLE_BLURB_ORDER: readonly SystemRole[] = [
  "guest",
  "limited_member",
  "member",
  "admin",
];

export function RolesSection() {
  return (
    <PermissionsSection icon="shield" title="Roles">
      {/* Four equal cells in a row; under `sm` they stack, so each blurb keeps
          a readable measure instead of four ~80px columns of wrapped words.
          The divider between cells follows: a left edge in the row, a top
          edge in the stack. */}
      <Box
        direction={{ base: "column", sm: "row" }}
        border
        rounded="lg"
        surface="card"
        overflow="hidden"
      >
        {ROLE_BLURB_ORDER.map((role, i) => (
          <Box
            key={`${role}-${i}`}
            fill="flex"
            padding="md"
            gap="2xs"
            border={i === 0 ? undefined : { base: "top", sm: "left" }}
          >
            <Text size="sm" weight="semibold">
              {SYSTEM_ROLE_NAMES[role]}
            </Text>
            <Text size="xs" variant="muted">
              {SYSTEM_ROLE_DESCRIPTIONS[role]}
            </Text>
          </Box>
        ))}
      </Box>
    </PermissionsSection>
  );
}
